type InvoiceEmailExclamationIconProps = {
  className?: string;
};

/** Bold exclamation mark (bar + dot) without a surrounding circle. */
export function InvoiceEmailExclamationIcon({ className }: InvoiceEmailExclamationIconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden className={className}>
      <rect x="10.25" y="3" width="3.5" height="12" rx="1.75" />
      <circle cx="12" cy="19" r="2.25" />
    </svg>
  );
}
